var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.78809 9.48975H2.72742C1.79443 9.48975 1.03809 10.2461 1.03809 11.1791V11.1791C1.03809 12.2451 2.01338 13.0447 3.05873 12.8356L3.2808 12.7912C4.15722 12.6159 4.78809 11.8464 4.78809 10.9526V5.06401C4.78809 3.69449 4.78809 3.00974 5.13839 2.49865C5.20313 2.40418 5.27587 2.31546 5.3558 2.23344C5.78827 1.78971 6.45973 1.65542 7.80265 1.38683L8.61091 1.22518C9.78394 0.990575 10.3705 0.873271 10.836 1.00586C11.3682 1.15744 11.8138 1.52276 12.0668 2.0149C12.2881 2.44535 12.2881 3.04348 12.2881 4.23975V4.23975M12.2881 7.98975V9.45261C12.2881 10.3464 11.6572 11.1159 10.7808 11.2912L10.5587 11.3356C9.51338 11.5447 8.53809 10.7451 8.53809 9.67908V9.67908C8.53809 8.74609 9.29443 7.98975 10.2274 7.98975H12.2881ZM12.2881 7.98975V4.23975M12.2881 4.23975L4.78809 5.73975",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.a3117a210739767727c25f9e3ce4db3c.svg";
export { ForwardRef as ReactComponent };